export const gridNamesForSortByCreatedAt = [
  'outboundReceipts',
  'inboundReceipts',
  'stockAdvices',
  'returnReceipts',
  'transfers',
  'complaints',
  'internalStockChanges',
  'expeditions',
]
